import {
  isCurrentView,
  hasCurrentView,
  animateElement,
} from "../../../shared/utils/view-util";
import { 
  updateInputLabelDisplay,
  toggleInputVisibilityAndState,
  clearInputValidationError,
  clearFieldValueAndValidation
} from "../../../shared/utils/input-utils";
import { replaceUrlParam } from "../../../shared/utils/url-util";

function toggleConditionalFields(
  shouldAnimate,
  isValid,
  select,
  input,
  conditionalField,
) {
  const fieldConditional = $(`${conditionalField}`);
  const selectElement = $(`${select}`);
  const selectedOption = $(`${select} option:selected`);
  const inputField = $(`${input}`);

  animateElement(shouldAnimate, fieldConditional, isValid);

  if (!isValid) {
    if (select) {
      selectElement.index(0);
      selectedOption.prop("selected", false);
    }
    if (input) {
      inputField.val("");
    }
  }
}

function initializePublicOfficialChangeDetection() {
  const radiosPipRelative = $(
    'input[type=radio][name="related_party_form[public_official_relative]"]',
  );
  const radioChecked =
    "#related_party_form_public_official_relative_true:checked";

  toggleConditionalFields(
    false,
    $(`${radioChecked}`).val(),
    "#related_party_form_public_official_relative_relationship",
    "#related_party_form_public_official_relative_full_name",
    ".conditional-field",
  );

  radiosPipRelative.on("change", () => {
    toggleConditionalFields(
      true,
      $(`${radioChecked}`).val(),
      "#related_party_form_public_official_relative_relationship",
      "#related_party_form_public_official_relative_full_name",
      ".conditional-field",
    );
  });
}

function initializeNationalityChangeDetection() {
  const radiosNationalityRelative = $(
    'input[type=radio][name="related_party_form[nationality_equivalent]"]',
  );
  const radioChecked =
    "#related_party_form_nationality_equivalent_false:checked";

  toggleConditionalFields(
    false,
    $(`${radioChecked}`).val(),
    "#related_party_form_country_of_birth",
    null,
    ".conditional-nationality",
  );

  radiosNationalityRelative.on("change", () => {
    toggleConditionalFields(
      true,
      $(`${radioChecked}`).val(),
      "#related_party_form_country_of_birth",
      null,
      ".conditional-nationality",
    );
  });
}

function toggleLegalShareholderAddress(shouldAnimate, isLegalShareholder) {
  animateElement(
    shouldAnimate,
    $("#legal-shareholder-address"),
    isLegalShareholder,
  );
}

function toggleShareholderDocuments(shouldAnimate, isLegalShareholder) {
  animateElement(
    shouldAnimate,
    $("#related_party_form_id_document_file_section"),
    !isLegalShareholder,
  );
  animateElement(
    shouldAnimate,
    $("#related_party_form_cipc_registration_certificate_file_section"),
    isLegalShareholder,
  );
}

function toggleShareholderIdentityFields(isIndividualShareholder) {
  const identityTypeSelect = document.getElementById('identity_type');
  const passportIssueDateInput = document.getElementById('passport_issue_date');
  const passportExpiryInput = document.getElementById('passport_expiry');
  const issuingCountrySelect = document.getElementById('identity_issuing_country');
  const passportDatesContainer = document.getElementById('passport_dates');

  toggleInputVisibilityAndState(identityTypeSelect, isIndividualShareholder, isIndividualShareholder);
  toggleInputVisibilityAndState(passportIssueDateInput, isIndividualShareholder, isIndividualShareholder);
  toggleInputVisibilityAndState(passportExpiryInput, isIndividualShareholder, isIndividualShareholder);
  toggleInputVisibilityAndState(issuingCountrySelect, isIndividualShareholder, isIndividualShareholder);

  if (passportDatesContainer) {
    passportDatesContainer.hidden = !isIndividualShareholder;
  }
}

function initializePartyTypeChangeDetection() {
  const partyType = "#related_party_form_party_type";
  const partyTypeElement = $(`${partyType}`);
  const isLegalShareholder =
    partyTypeElement.val() === "shareholder_legal_entity";
  const isIndividualShareholder = partyTypeElement.val() === 'shareholder';

  toggleShareholderDocuments(false, isLegalShareholder);
  toggleShareholderIdentityFields(isIndividualShareholder);
  toggleLegalShareholderAddress(false, isLegalShareholder);
  toggleInputLabels();
  toggleConditionalFields(
    false,
    !isLegalShareholder,
    null,
    null,
    ".conditional-party-type",
  );

  $(`${partyType}`).change(function () {
    const isShareholder = partyTypeElement.val() === "shareholder";

    if (!isShareholder) {
      $("#related_party_form_nationality_equivalent_true")
        .prop("checked", true)
        .change();
    }

    toggleShareholderDocuments(true, !isShareholder);
    toggleShareholderIdentityFields(isShareholder);
    toggleLegalShareholderAddress(true, !isShareholder);
    toggleInputLabels();
    toggleConditionalFields(
      true,
      isShareholder,
      null,
      null,
      ".conditional-party-type",
    );
  });
}

function updateRequiredShareholderQueryParam(paramValue) {
  $(".require-shareholder-href").each(function () {
    const oldUrl = $(this).attr("href");
    const newUrl = replaceUrlParam(
      false,
      oldUrl,
      "require_shareholder",
      paramValue,
    );
    $(this).attr("href", newUrl);
  });
}

function showRelatedPartiesContainer(
  shouldAnimate,
  SHAREHOLDER_INFO_REQUIRED_SUB_TYPE,
) {
  const relatedPartiesContainer = $("#related-parties-container");
  const merchantType = $(
    "#related_parties_overview_form_sub_type_of_merchant",
  ).val();
  const radioShareholderRequiredChecked = $(
    "#related_parties_overview_form_shareholders_required_true:checked",
  );
  const radioShareholderRequiredUnchecked = $(
    "#related_parties_overview_form_shareholders_required_false:checked",
  );

  if (
    merchantType === SHAREHOLDER_INFO_REQUIRED_SUB_TYPE &&
    radioShareholderRequiredChecked.val() === undefined &&
    radioShareholderRequiredUnchecked.val() === undefined
  ) {
    relatedPartiesContainer.hide();
  } else {
    animateElement(shouldAnimate, relatedPartiesContainer, true);
  }
}

function checkShareholderRequiredVal(
  shouldAnimate,
  SHAREHOLDER_INFO_REQUIRED_SUB_TYPE,
) {
  const radioShareholderRequiredChecked = $(
    "#related_parties_overview_form_shareholders_required_true:checked",
  );
  const shareholderInfo = $("#shareholder-info");
  const merchantType = $(
    "#related_parties_overview_form_sub_type_of_merchant",
  ).val();
  const isRequired =
    radioShareholderRequiredChecked.val() === "true" &&
    merchantType === SHAREHOLDER_INFO_REQUIRED_SUB_TYPE;

  isRequired
    ? updateRequiredShareholderQueryParam("true")
    : updateRequiredShareholderQueryParam("false");
  animateElement(shouldAnimate, shareholderInfo, isRequired);
}

function add_file_block(element, event) {
  const files = event.target.files;
  const id = $(element).attr("id");
  const container = $(`#${id}_file_grid`);
  container.children().hide();

  $.each(files, function (_key, value) {
    container
      .append(
        $("#document_uploader_template")
          .html()
          .replace("#DOC_NAME#", value.name),
      )
      .fadeIn(300);
    $(".delete_file").on("click", function () {
      $(this)
        .closest(container)
        .fadeOut(300, function () {
          $(this).children().remove();
        });
    });
  });
}

function setupPassportDatepickers() {
  if (typeof flatpickr !== 'function') {
    return;
  }

  ['#passport_issue_date', '#passport_expiry', '#permit_issue_date', '#permit_expiry'].forEach(function(selector) {
    const input = document.querySelector(selector);
    if (!input || input._flatpickr) {
      return;
    }

    flatpickr(input, {
      dateFormat: 'Y-m-d',
      allowInput: true,
    });
  });
}

function initializeIdentityDocumentFields(enablePermitFields = true) {
  const identityTypeSelect = document.getElementById('identity_type');
  const passportDatesContainer = document.getElementById('passport_dates');
  const permitFieldsContainer = document.getElementById('permit_fields');
  const issuingCountrySelect = document.getElementById('identity_issuing_country');
  const passportIssueDateInput = document.getElementById('passport_issue_date');
  const passportExpiryInput = document.getElementById('passport_expiry');
  const permitNumberInput = document.getElementById('permit_number');
  const permitTypeInput = document.getElementById('permit_type');
  const permitIssueDateInput = document.getElementById('permit_issue_date');
  const permitExpiryInput = document.getElementById('permit_expiry');
  const permitDocumentSection = document.getElementById('permit_document_section');
  const permitLabels = (permitTypeInput && permitTypeInput.dataset.permitLabels)
    ? JSON.parse(permitTypeInput.dataset.permitLabels)
    : {};

  if (!identityTypeSelect) {
    return;
  }

  setupPassportDatepickers();

  function updatePermitDocumentSection() {
    if (!permitDocumentSection) { return; }

    if (!enablePermitFields) {
      permitDocumentSection.hidden = true;

      const fileInput = permitDocumentSection.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = '';
      }

      const fileGrid = permitDocumentSection.querySelector('.files');
      if (fileGrid) {
        fileGrid.querySelectorAll('.file.pending').forEach(function(el) { el.remove(); });
        fileGrid.querySelectorAll('.file.add-file').forEach(function(el) { el.style.display = ''; });
      }

      const filesUploaded = permitDocumentSection.querySelector('.files-uploaded');
      if (filesUploaded) {
        filesUploaded.hidden = true;
      }

      return;
    }

    const hasPermitType = permitTypeInput && permitTypeInput.value !== '';
    permitDocumentSection.hidden = !hasPermitType;

    if (hasPermitType) {
      const titleEl = permitDocumentSection.querySelector('h6.card-subtitle');
      const nameEl = permitDocumentSection.querySelector('.file-info .name');
      const label = permitLabels[permitTypeInput.value] || 'Permit/visa document';
      if (titleEl) { titleEl.textContent = label; }
      if (nameEl) { nameEl.textContent = label; }
    } else {
      const fileInput = permitDocumentSection.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = '';
      }
      const fileGrid = permitDocumentSection.querySelector('.files');
      if (fileGrid) {
        fileGrid.querySelectorAll('.file.pending').forEach(function(el) { el.remove(); });
        fileGrid.querySelectorAll('.file.add-file').forEach(function(el) { el.style.display = ''; });
      }
      const filesUploaded = permitDocumentSection.querySelector('.files-uploaded');
      if (filesUploaded) {
        filesUploaded.hidden = true;
      }
    }
  }

  function toggleFields() {
    const passportSelected = identityTypeSelect.value === 'passport';

    if (passportDatesContainer) {
      passportDatesContainer.hidden = !passportSelected;
    }

    toggleInputVisibilityAndState(passportIssueDateInput, passportSelected, passportSelected);
    toggleInputVisibilityAndState(passportExpiryInput, passportSelected, passportSelected);
    toggleInputVisibilityAndState(issuingCountrySelect, passportSelected, passportSelected);

    const permitRequired = enablePermitFields && passportSelected && issuingCountrySelect && issuingCountrySelect.value !== '' && issuingCountrySelect.value !== 'ZA';

    if (permitFieldsContainer) {
      permitFieldsContainer.hidden = !permitRequired;
    }

    toggleInputVisibilityAndState(permitNumberInput, permitRequired, permitRequired);
    toggleInputVisibilityAndState(permitTypeInput, permitRequired, permitRequired);
    toggleInputVisibilityAndState(permitIssueDateInput, permitRequired, permitRequired);
    toggleInputVisibilityAndState(permitExpiryInput, permitRequired, permitRequired);

    updatePermitDocumentSection();
  }

  const identityFields = [
    identityTypeSelect,
    passportIssueDateInput,
    passportExpiryInput,
    issuingCountrySelect,
    permitNumberInput,
    permitTypeInput,
    permitIssueDateInput,
    permitExpiryInput,
  ];

  identityFields.forEach(function(field) {
    if (!field) {
      return;
    }

    const eventType = field.tagName === 'SELECT' ? 'change' : 'input';
    field.addEventListener(eventType, function() {
      clearInputValidationError(field);
    });

    if (field.tagName !== 'SELECT') {
      field.addEventListener('change', function() {
        clearInputValidationError(field);
      });
    }
  });

  identityTypeSelect.addEventListener('change', toggleFields);
  if (issuingCountrySelect) {
    issuingCountrySelect.addEventListener('change', toggleFields);
  }
  if (enablePermitFields && permitTypeInput) {
    permitTypeInput.addEventListener('change', updatePermitDocumentSection);
  }

  toggleFields();
}

function updatePlaceholderAndError(
  isSelect,
  isRequired,
  shouldToggleRequired,
  selector,
  label,
  previousLabel,
) {
  const elementBlock = document.getElementsByClassName(selector);

  if (isSelect) {
    $(`#${selector} option:first`)
      .text(isRequired ? `${label} *` : `${label}`)
      .change();
  }

  if (elementBlock && elementBlock[0] && elementBlock[0].children) {
    if (elementBlock[0].children[1] && label) {
      elementBlock[0].children[1].innerHTML = isRequired
        ? `${label} <abbr title="required">*</abbr>`
        : `${label}`;
    }

    if (
      shouldToggleRequired &&
      elementBlock[0].children[1] &&
      elementBlock[0].children[2]
    ) {
      isRequired
        ? elementBlock[0].children[0].classList.add("is-invalid")
        : elementBlock[0].children[0].classList.remove("is-invalid");
    }

    if (elementBlock[0].children[2]) {
      elementBlock[0].children[2].innerHTML =
        elementBlock[0].children[2].innerHTML.replace(previousLabel, label);
    }
  }
}

function updateFullNameField(
  isSelect,
  isRequired,
  shouldToggleRequired,
  selector,
  label,
  previousLabel,
) {
  updateInputLabelDisplay(
    "label[for='related_party_form_full_name']",
    "#related_party_form_full_name",
    label,
  );
  updatePlaceholderAndError(
    isSelect,
    isRequired,
    shouldToggleRequired,
    selector,
    label,
    previousLabel,
  );
}

function updateIdentificationField(
  isSelect,
  isRequired,
  shouldToggleRequired,
  selector,
  label,
  previousLabel,
) {
  updateInputLabelDisplay(
    "label[for='related_party_form_identification']",
    "#related_party_form_identification",
    label,
  );
  updatePlaceholderAndError(
    isSelect,
    isRequired,
    shouldToggleRequired,
    selector,
    label,
    previousLabel,
  );
}

function updateCountryOfResidenceField(
  isSelect,
  isRequired,
  shouldToggleRequired,
  selector,
  label,
  previousLabel,
) {
  updateInputLabelDisplay(
    "label[for='country_of_residence']",
    "#related_party_form_country_of_residence",
    label,
  );
  updatePlaceholderAndError(
    isSelect,
    isRequired,
    shouldToggleRequired,
    selector,
    label,
    previousLabel,
  );
}

function toggleInputLabels() {
  const type = $("#related_party_form_party_type :selected").val();
  if (!type) {
    return;
  }

  if (type === "shareholder") {
    updateFullNameField(
      false,
      true,
      false,
      "related_party_form_full_name",
      "Name and surname",
      "Business name",
    );
    updateIdentificationField(
      false,
      true,
      true,
      "related_party_form_identification",
      "ID/Passport number",
      "Business registration number",
    );
    updateCountryOfResidenceField(
      true,
      true,
      false,
      "related_party_form_country_of_residence",
      "Country of residence",
      "Country of incorporation",
    );
  } else {
    updateFullNameField(
      false,
      true,
      false,
      "related_party_form_full_name",
      "Business name",
      "Name and surname",
    );
    updateIdentificationField(
      false,
      false,
      true,
      "related_party_form_identification",
      "Business registration number",
      "ID/Passport number",
    );
    updateCountryOfResidenceField(
      true,
      true,
      false,
      "related_party_form_country_of_residence",
      "Country of incorporation",
      "Country of residence",
    );
  }
}

// Expose add_file_block for inline HTML event handlers
window.add_file_block = add_file_block;

// --- Related parties index (overview) ---
document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".portal.related_parties.index")) {
    return;
  }

  const SHAREHOLDER_INFO_REQUIRED_SUB_TYPE =
    document.getElementById("new_related_parties_overview_form") &&
    document
      .getElementById("new_related_parties_overview_form")
      .getAttribute("data-entityType");

  checkShareholderRequiredVal(false, SHAREHOLDER_INFO_REQUIRED_SUB_TYPE);
  showRelatedPartiesContainer(false, SHAREHOLDER_INFO_REQUIRED_SUB_TYPE);

  $(
    'input[type=radio][name="related_parties_overview_form[shareholders_required]"]',
  ).on("change", () => {
    $("#shareholders-required-text").removeClass("text-danger");
    checkShareholderRequiredVal(true, SHAREHOLDER_INFO_REQUIRED_SUB_TYPE);
    showRelatedPartiesContainer(true, SHAREHOLDER_INFO_REQUIRED_SUB_TYPE);
  });
});

// --- Related party new/edit/create/update ---
document.addEventListener("DOMContentLoaded", function () {
  if (
    !hasCurrentView([
      ".portal.related_parties.new",
      ".portal.related_parties.edit",
      ".portal.related_parties.create",
      ".portal.related_parties.update",
    ])
  ) {
    return;
  }

  initializePublicOfficialChangeDetection();
  initializeNationalityChangeDetection();

  const partyType = $("#related_party_form_party_type").val();

  if (partyType === "legal_entity") {
    updateIdentificationField(
      false,
      false,
      true,
      "related_party_form_identification",
      "Registration number",
      null,
    );
  } else {
    updateIdentificationField(
      false,
      true,
      true,
      "related_party_form_identification",
      "ID/Passport number",
      null,
    );
  }

  $("#related_party_form_phone_number").on("input", function (e) {
    if (e && e.target && e.target.value) {
      e.target.value = e.target.value.replace(/\s+/g, "");
    }
  });

  initializeIdentityDocumentFields();
});

// --- Related party shareholder ---
document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".portal.related_parties.shareholder")) {
    return;
  }

  initializePartyTypeChangeDetection();
  initializeNationalityChangeDetection();
  initializeIdentityDocumentFields(false);
});
